import {ComputedRef, InjectionKey, Ref} from "vue";

export const FileManagerRootInjectionKey = Symbol() as InjectionKey<ComputedRef<string> | Ref<string>>;